import React from 'react'

import { initDatadogLogger, initDatadogRum } from '../../utils/datadog'

import MixpanelProvider from './hooks/MixpanelProvider'
import OptimizelyProvider from './hooks/OptimizelyProvider'

initDatadogLogger()
initDatadogRum()

const UserAnalytics = ({ children }: { children: React.ReactNode }) => {
  return (
    <OptimizelyProvider>
      <MixpanelProvider>{children}</MixpanelProvider>
    </OptimizelyProvider>
  )
}

export default UserAnalytics
